<template>
    <img class="logo w-[195px] h-auto" src="/images/logo.svg" alt="Logo" />
</template>
<script>
export default {
    props: {
        name: String,
    },
}
</script>
